import { DropdownMenu, Loader } from '@octopus-do/octopus-storybook'
import { OctopusMonoLogo } from '@octopus-do/octopus-storybook/icons'
import { forwardRef } from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  url: string | null
  loading: boolean
}

export const AvatarButton = forwardRef<HTMLButtonElement, Props>(
  ({ url, loading }, ref) => {
    const { open, active } = DropdownMenu.useTrigger()

    return (
      <button
        disabled={loading}
        ref={ref}
        onClick={open}
        type="button"
        className={clsJoin(
          css.avatar_button,
          active && css.active,
          loading && css.loading
        )}
      >
        {loading && <Loader medium threeDots />}
        {url && <img src={url} alt="team avatar" className={css.image} />}
        {!url && <OctopusMonoLogo className={css.empty_logo} />}
      </button>
    )
  }
)
